import "./NavienWaterHeaterService.module.css";
import Header from "@/reusable_sections/Header";
import NavienHero from "./sections/NavienHero";
import NavienServices from "./sections/NavienServices";
import NavienFaq from "./sections/NavienFaq";
import Footer from "@/reusable_sections/Footer";
export default function NavienWaterHeaterServicePage() {
  return <div>
      <Header />
      <NavienHero />
      <NavienServices />
      <NavienFaq />
      <Footer />
    </div>;
}